import React, { createContext, useContext, useState } from 'react';

import sv from './sv.json';
import en from './en.json';

const translations = {
  sv: {
    ...sv,
    home_title: 'Är din dator redo för Windows 11?',
    home_subtitle1: 'Fyll i din e-postadress så får du direkt ladda ned vårt testprogram.',
    home_subtitle2: 'Fungerar på både Windows 10 och Windows 11!',
  },
  en: {
    ...en,
    home_title: 'Is your PC ready for Windows 11?',
    home_subtitle1: 'Enter your email to immediately download our test tool.',
    home_subtitle2: 'Works on both Windows 10 and Windows 11!',
  },
};

const TranslationContext = createContext({
  language: 'sv',
  toggleLanguage: () => {},
  t: (key) => key,
});

export const TranslationProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('lang') || 'sv';
    }
    return 'sv';
  });
  const toggleLanguage = () => {
    setLanguage((prev) => {
      const next = prev === 'sv' ? 'en' : 'sv';
      if (typeof window !== 'undefined') {
        localStorage.setItem('lang', next);
      }
      return next;
    });
  };
  const t = (key) => translations[language][key] || key;

  return (
    <TranslationContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);
